// extracted by mini-css-extract-plugin
module.exports = {"step":"step__JqMVm","number":"number__VHCg0"};